document.addEventListener('DOMContentLoaded', function() {
  fetchCartState().then(() => {
    initializeVariantTable();
  });
});

let eventsInitialized = false;
let isCartOperationInProgress = false;
let bubbleElement = null;

function fetchCartState() {
  return fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      updateVariantTableUI(cart);
      return cart;
    })
    .catch(error => {
      console.error('Error fetching cart state:', error);
      if (!eventsInitialized) {
        initializeVariantTable();
      }
      return { items: [] };
    });
}

function updateVariantTableUI(cart) {
  const variantInputs = document.querySelectorAll('.quantity__input[data-quantity-variant-id]');
  
  if (variantInputs.length === 0) return;

  variantInputs.forEach(input => {
    const variantId = input.dataset.quantityVariantId;
    let cartQuantity = 0;
    
    const cartItem = cart.items.find(item => item.id.toString() === variantId.toString());
    if (cartItem) {
      cartQuantity = cartItem.quantity;
    }
    
    input.value = cartQuantity;
    input.dataset.cartQuantity = cartQuantity;
    
    updateQuantityDisplay(variantId, cartQuantity);
  });
}

function updateQuantityDisplay(variantId, quantity) {
  const desktopControls = document.querySelector(`.variant-table tr[data-variant-id="${variantId}"] .cart-controls`);
  if (desktopControls) {
    if (quantity > 0) {
      desktopControls.querySelector('.add-button-container').style.display = 'none';
      desktopControls.querySelector('quantity-input').style.display = 'flex';
      
      const input = desktopControls.querySelector('.quantity__input');
      if (input) {
        input.value = quantity;
        input.dataset.cartQuantity = quantity;
      }
    } else {
      desktopControls.querySelector('.add-button-container').style.display = 'block';
      desktopControls.querySelector('quantity-input').style.display = 'none';
    }
  }
  
  const mobileItem = document.querySelector(`.mobile-variant-item[data-variant-id="${variantId}"]`);
  if (mobileItem) {
    const addButton = mobileItem.querySelector('.add-to-cart-button');
    let quantityControl = mobileItem.querySelector('quantity-input');
    
    if (!quantityControl) {
      const desktopQuantity = document.querySelector(`tr[data-variant-id="${variantId}"] quantity-input`);
      if (desktopQuantity) {
        quantityControl = desktopQuantity.cloneNode(true);
        quantityControl.classList.add('mobile-quantity');
        
        quantityControl.querySelectorAll('.quantity__button').forEach(button => {
          button.addEventListener('click', handleVariantQuantityChange);
        });
        
        quantityControl.querySelector('.quantity__input').addEventListener('change', handleVariantQuantityInputChange);
        
        addButton.parentNode.appendChild(quantityControl);
      }
    }
    
    if (quantityControl) {
      if (quantity > 0) {
        addButton.style.display = 'none';
        quantityControl.style.display = 'flex';
        
        const input = quantityControl.querySelector('.quantity__input');
        if (input) {
          input.value = quantity;
          input.dataset.cartQuantity = quantity;
        }
      } else {
        addButton.style.display = 'block';
        quantityControl.style.display = 'none';
      }
    }
  }
}

function initializeVariantTable() {
  if (eventsInitialized) return;
  
  document.querySelectorAll('.add-to-cart-button').forEach(button => {
    button.addEventListener('click', handleVariantAddToCart);
  });

  document.querySelectorAll('.quantity__button').forEach(button => {
    button.addEventListener('click', handleVariantQuantityChange);
  });

  document.querySelectorAll('.quantity__input').forEach(input => {
    input.addEventListener('change', handleVariantQuantityInputChange);
  });
  
  eventsInitialized = true;
}

function handleVariantAddToCart(event) {
  event.preventDefault();
  
  if (isCartOperationInProgress) return;
  isCartOperationInProgress = true;
  
  const button = event.currentTarget;
  const variantId = button.dataset.variantId;
  
  if (!variantId) {
    isCartOperationInProgress = false;
    return;
  }
  
  button.classList.add('loading');
  const spinner = button.querySelector('.loading-spinner');
  if (spinner) spinner.style.display = 'inline-block';
  button.disabled = true;
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      items: [{id: variantId, quantity: 1}]
    }),
  })
  .then(response => response.json())
  .then(data => {
    if (typeof window.woowUpTrackAddToCartFromCartAddResponse === 'function') {
      window.woowUpTrackAddToCartFromCartAddResponse(data);
    }
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartItem = cart.items.find(item => item.id.toString() === variantId.toString());
        const quantity = cartItem ? cartItem.quantity : 1;
        
        updateQuantityDisplay(variantId, quantity);
        
        updateVariantCartDrawer(true);
        updateVariantCartIconBubble(cart);
        
        return cart;
      });
  })
  .catch(error => {
    console.error('Error:', error);
  })
  .finally(() => {
    button.disabled = false;
    button.classList.remove('loading');
    if (spinner) spinner.style.display = 'none';
    isCartOperationInProgress = false;
  });
}

function handleVariantQuantityChange(event) {
  if (isCartOperationInProgress) return;
  isCartOperationInProgress = true;
  
  const button = event.currentTarget;
  const isPlus = button.name === 'plus';
  const quantityInput = button.closest('quantity-input').querySelector('.quantity__input');
  
  if (!quantityInput) {
    isCartOperationInProgress = false;
    return;
  }
  
  const variantId = quantityInput.dataset.quantityVariantId;
  const currentValue = parseInt(quantityInput.value, 10);
  const maxValue = quantityInput.max ? parseInt(quantityInput.max, 10) : Infinity;
  const minValue = quantityInput.min ? parseInt(quantityInput.min, 10) : 0;
  
  let newValue = isPlus ? Math.min(currentValue + 1, maxValue) : Math.max(currentValue - 1, minValue);
  
  quantityInput.value = newValue;
  
  document.querySelectorAll(`.quantity__input[data-quantity-variant-id="${variantId}"]`).forEach(input => {
    input.value = newValue;
  });
  
  if (newValue === 0) {
    updateQuantityDisplay(variantId, 0);
  }
  
  updateVariantCartQuantity(variantId, newValue);
}

function handleVariantQuantityInputChange(event) {
  if (isCartOperationInProgress) return;
  isCartOperationInProgress = true;
  
  const input = event.currentTarget;
  const variantId = input.dataset.quantityVariantId;
  const newValue = parseInt(input.value, 10) || 0;
  
  // Sync all inputs with the same variant ID
  document.querySelectorAll(`.quantity__input[data-quantity-variant-id="${variantId}"]`).forEach(input => {
    input.value = newValue;
  });
  
  if (newValue === 0) {
    updateQuantityDisplay(variantId, 0);
  }
  
  updateVariantCartQuantity(variantId, newValue);
}

function updateVariantCartQuantity(variantId, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    }),
  })
  .then(response => response.json())
  .then(cart => {
    document.querySelectorAll(`.quantity__input[data-quantity-variant-id="${variantId}"]`).forEach(input => {
      input.value = quantity;
      input.dataset.cartQuantity = quantity;
    });
    
    updateQuantityDisplay(variantId, quantity);
    
    if (cart.item_count === 0) {
      handleEmptyCart();
    } else {
      updateVariantCartDrawer();
    }
    
    updateVariantCartIconBubble(cart);
  })
  .catch(error => {
    console.error('Error:', error);
    fetchCartState();
  })
  .finally(() => {
    isCartOperationInProgress = false;
  });
}

function handleEmptyCart() {
  const cartDrawer = document.querySelector('cart-drawer');
  
  if (cartDrawer && !cartDrawer.classList.contains('is-empty')) {
    fetch('/?section_id=cart-drawer')
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const newDocument = parser.parseFromString(html, 'text/html');
        const newDrawerContent = newDocument.querySelector('.drawer__inner');
        
        if (newDrawerContent && cartDrawer) {
          const currentDrawerContent = cartDrawer.querySelector('.drawer__inner');
          if (currentDrawerContent) {
            currentDrawerContent.innerHTML = newDrawerContent.innerHTML;
          }
          
          cartDrawer.classList.add('is-empty');
        }
      })
      .catch(error => console.error('Error updating empty cart drawer:', error));
  }
}

function updateVariantCartDrawer(openDrawer = false) {
  fetch('/?section_id=cart-drawer')
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(html, 'text/html');
      const newDrawerContent = newDocument.querySelector('.drawer__inner');
      const cartDrawer = document.querySelector('cart-drawer');

      if (newDrawerContent && cartDrawer) {
        const currentDrawerContent = cartDrawer.querySelector('.drawer__inner');
        if (currentDrawerContent) {
          currentDrawerContent.innerHTML = newDrawerContent.innerHTML;
          applyRecommendationStyles(cartDrawer);
        }
        
        const isEmpty = newDrawerContent.classList.contains('is-empty');
        cartDrawer.classList.toggle('is-empty', isEmpty);
        
        if (!isEmpty) {
          applyRecommendationStyles(cartDrawer);
        }
        
        if (openDrawer) {
          cartDrawer.open();
          setTimeout(() => {
            applyRecommendationStyles(cartDrawer);
          }, 50);
        }
      }
    })
    .catch(error => console.error('Error:', error));
}

function applyRecommendationStyles(cartDrawer) {
  if (!cartDrawer) return;
  
  const hasRecommendations = !!document.querySelector('.cart-recommendations-desktop, .cart-recommendations-mobile');
  
  if (hasRecommendations) {
    const drawerInner = cartDrawer.querySelector('.drawer__inner');
    if (drawerInner) {
      drawerInner.classList.add('cart-drawer-pinflag-width');
      
      const pinflag = cartDrawer.querySelector('#CartDrawer-Pinflag');
      if (pinflag) {
        pinflag.classList.add('cart-drawer-pinflag-flex-column');
      }
      
      const footer = cartDrawer.querySelector('.drawer__footer');
      if (footer) {
        footer.style.display = 'block';
        footer.style.visibility = 'visible';
      }
      
      const checkoutButton = cartDrawer.querySelector('#CartDrawer-Checkout');
      if (checkoutButton) {
        checkoutButton.style.display = 'block';
        checkoutButton.style.visibility = 'visible';
      }
    }
  }
}

function updateVariantCartIconBubble(cartData = null) {
  if (cartData) {
    updateCartBubbleUI(cartData);
    return;
  }
  
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      updateCartBubbleUI(cart);
    })
    .catch(error => console.error('Error:', error));
}

function updateCartBubbleUI(cart) {
  const cartIconBubble = document.querySelector('#cart-icon-bubble');
  if (!cartIconBubble) return;
  
  const itemCount = cart.item_count;
  bubbleElement = cartIconBubble.querySelector('.cart-count-bubble');
  
  if (itemCount === 0) {
    if (bubbleElement) {
      bubbleElement.remove();
      bubbleElement = null;
    }
    return;
  }
  
  if (!bubbleElement) {
    bubbleElement = document.createElement('div');
    bubbleElement.className = 'cart-count-bubble';
    bubbleElement.innerHTML = `<span aria-hidden="true">${itemCount}</span><span class="visually-hidden">${itemCount} artículo(s)</span>`;
    cartIconBubble.appendChild(bubbleElement);
  } else {
    const counterElement = bubbleElement.querySelector('span[aria-hidden="true"]');
    if (counterElement) {
      counterElement.textContent = itemCount;
    }
    
    const visibleElement = bubbleElement.querySelector('.visually-hidden');
    if (visibleElement) {
      visibleElement.textContent = `${itemCount} artículo(s)`;
    }
    
    bubbleElement.classList.remove('hide');
  }
}

function handleViewportChange() {
  const isMobile = window.innerWidth <= 767;
  const desktopTable = document.querySelector('.variant-table.desktop-only');
  const mobileList = document.querySelector('.mobile-variant-list');
  
  if (desktopTable && mobileList) {
    if (isMobile) {
      desktopTable.style.display = 'none';
      mobileList.style.display = 'block';
    } else {
      desktopTable.style.display = 'table';
      mobileList.style.display = 'none';
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const cartDrawer = document.querySelector('cart-drawer');
  
  if (cartDrawer) {
    cartDrawer.addEventListener('drawer-opened', function() {
      applyRecommendationStyles(cartDrawer);
    });
    
    if (cartDrawer.hasAttribute('open')) {
      applyRecommendationStyles(cartDrawer);
    }
  }
  
  handleViewportChange();
  
  window.addEventListener('resize', handleViewportChange);
});